export const GET_ORGANIZATION_SPONSORSHIP_LIST = null;
export const SELECTED_ORGANIZATION_SPONSORSHIP_ID = null;